/**
 * คลาสสำหรับจัดการการแสดง Toast notification ด้วย toastr ของ Metronic
 * @author เต้ย
 */
class ModuleToast {
  /**
   * สร้าง instance ของ Toast
   * @param {Template} template - Template instance
   */
  constructor(template) {
    this.template = template;
    this.initToastrOptions();
  }

  /**
   * ตั้งค่าเริ่มต้นสำหรับ toastr
   * @private
   */
  initToastrOptions() {
    // ตั้งค่าเริ่มต้นสำหรับ toastr ตาม Metronic
    toastr.options = {
      "closeButton": false,
      "debug": false,
      "newestOnTop": false,
      "progressBar": false,
      "positionClass": "toastr-top-right",
      "preventDuplicates": false,
      "onclick": null,
      "showDuration": "300",
      "hideDuration": "1000",
      "timeOut": "5000",
      "extendedTimeOut": "1000",
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "fadeIn",
      "hideMethod": "fadeOut"
    };
  }

  /**
   * แสดง Toast notification
   * @param {Object} config - ตัวเลือกสำหรับการแสดง Toast
   * @param {string} [config.heading] - หัวข้อของ Toast
   * @param {string} [config.type="info"] - ประเภทของ Toast (success, error, warning, info)
   * @param {string} [config.text=""] - ข้อความที่จะแสดงใน Toast
   * @param {string} [config.position="top-right"] - ตำแหน่งที่จะแสดง Toast
   * @param {number} [config.timeOut=5000] - เวลาที่จะแสดง Toast (มิลลิวินาที)
   */
  showToast = (config) => {
    // บันทึกค่า options เดิม
    const originalOptions = { ...toastr.options };

    // ตั้งค่าตัวเลือกตามที่กำหนด
    if (config.position) {
      toastr.options.positionClass = `toastr-${config.position}`;
    }

    if (config.timeOut) {
      toastr.options.timeOut = config.timeOut;
    }

    if (config.closeButton !== undefined) {
      toastr.options.closeButton = config.closeButton;
    }

    if (config.progressBar !== undefined) {
      toastr.options.progressBar = config.progressBar;
    }

    // แสดง toast ตามประเภท
    const type = config.type || "info";
    const title = config.heading || "";
    const message = config.text || "";

    switch (type) {
      case "success":
        toastr.success(message, title);
        break;
      case "error":
        toastr.error(message, title);
        break;
      case "warning":
        toastr.warning(message, title);
        break;
      case "info":
      default:
        toastr.info(message, title);
        break;
    }

    // คืนค่า options เดิม
    toastr.options = originalOptions;
  }

  /**
   * แสดง Toast สำเร็จ
   * @param {string} text - ข้อความที่จะแสดง
   * @param {string} [heading="สำเร็จ"] - หัวข้อของ Toast
   * @param {Object} [options={}] - ตัวเลือกเพิ่มเติม
   */
  success = (text, heading = "สำเร็จ", options = {}) => {
    this.showToast({
      heading: heading,
      text: text,
      type: "success",
      ...options
    });
  }

  /**
   * แสดง Toast ข้อผิดพลาด
   * @param {string} text - ข้อความที่จะแสดง
   * @param {string} [heading="เกิดข้อผิดพลาด"] - หัวข้อของ Toast
   * @param {Object} [options={}] - ตัวเลือกเพิ่มเติม
   */
  error = (text, heading = "เกิดข้อผิดพลาด", options = {}) => {
    this.showToast({
      heading: heading,
      text: text,
      type: "error",
      ...options
    });
  }

  /**
   * แสดง Toast แจ้งเตือน
   * @param {string} text - ข้อความที่จะแสดง
   * @param {string} [heading="แจ้งเตือน"] - หัวข้อของ Toast
   * @param {Object} [options={}] - ตัวเลือกเพิ่มเติม
   */
  warning = (text, heading = "แจ้งเตือน", options = {}) => {
    this.showToast({
      heading: heading,
      text: text,
      type: "warning",
      ...options
    });
  }

  /**
   * แสดง Toast ข้อมูล
   * @param {string} text - ข้อความที่จะแสดง
   * @param {string} [heading="ข้อมูล"] - หัวข้อของ Toast
   * @param {Object} [options={}] - ตัวเลือกเพิ่มเติม
   */
  info = (text, heading = "ข้อมูล", options = {}) => {
    this.showToast({
      heading: heading,
      text: text,
      type: "info",
      ...options
    });
  }

  /**
   * กำหนดค่าเริ่มต้นใหม่สำหรับ toastr
   * @param {Object} options - ตัวเลือกใหม่
   */
  setDefaultOptions = (options) => {
    toastr.options = { ...toastr.options, ...options };
  }
}